var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{staticClass:"hover-green",attrs:{"icon":"PrinterIcon","size":"16"},on:{"click":_vm.print}})}
var staticRenderFns = []

export { render, staticRenderFns }